/* istanbul ignore file */
export type { Props as AgendaItemProps } from './agendaItem'
export { default as AgendaItem } from './agendaItem'
